'use client'

import React, { useState } from 'react'
import { Button, ButtonContent } from '@/ui/atoms/Button'
import { ExpertGuidanceModal } from './ExpertGuidanceModal'

interface ExpertGuidanceCTAProps {
  appearance?: 'primary' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  sourcePageType?: string
  sourceCtaPlacement?: string
  className?: string
}

export function ExpertGuidanceCTA({
  appearance = 'secondary',
  size = 'sm',
  sourcePageType,
  sourceCtaPlacement,
  className,
}: ExpertGuidanceCTAProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant={appearance}
        size={size}
        className={className}
        onClick={() => setOpen(true)}
      >
        <ButtonContent
          showIconLeft
          iconLeft="user-3-line"
          label="Talk to a Battery Expert"
        />
      </Button>
      <ExpertGuidanceModal
        open={open}
        onOpenChange={setOpen}
        sourcePageType={sourcePageType}
        sourceCtaPlacement={sourceCtaPlacement}
      />
    </>
  )
}
